/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_ExistsInputs */

const id_tld_pricing_exists = /** @type {(inputs: Tld_Pricing_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLD ini sudah ada di daftar.`)
};

const en_tld_pricing_exists = /** @type {(inputs: Tld_Pricing_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This TLD is already on the list.`)
};

/**
* | output |
* | --- |
* | "This TLD is already on the list." |
*
* @param {Tld_Pricing_ExistsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_exists = /** @type {((inputs?: Tld_Pricing_ExistsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_ExistsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_exists(inputs)
	return id_tld_pricing_exists(inputs)
});